import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';

const inputSchema = z.object({
  contentFeedId: z.number().describe('The content feed ID'),
});

async function execute({
  input: {contentFeedId},
  toolUtils: {agentScratchpad},
}: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>): Promise<ToolResult> {
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  const availableFeeds = await contentFeedsApi.getContentFeeds();

  if (!availableFeeds.some((f) => f.id === contentFeedId)) {
    return toolError(
      `Content feed with ID ${contentFeedId} is not available. Available content feeds: ${availableFeeds.map((f) => `${f.id}: ${f.name}`).join(', ')}`,
    );
  }

  validatedScratchpad.card.contentFeedId = contentFeedId;

  return toolResult(`Content feed set to ${contentFeedId}`);
}

export default function setContentFeedTool() {
  return tool({
    name: V2CardAgentToolName.SetContentFeed,
    displayName: 'Setting content feed',
    description: 'Set the content feed ID for the content card',
    inputSchema,
    execute,
  });
}
